import React from 'react'

// mui
import { Typography, Grid, Container } from '@mui/material'

// collections
import EquipmentListWithSearch from './collections/EquipmentRequestListWithSearch/EquipmentRequestListWithSearch.collection'

// wrappers
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper'

// queries
import { GET_ALL_EQUIPMENT_REQUESTS_WITH_FULL_DETAIL } from '../../../graphql/equipmentRequest/equipmentRequest.queries'

export default function EquipmentRequestList({ ...pageProps }) {

    return (<div id="EquipmentRequestList">
        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6}><Typography variant="h2">Equipment Requests</Typography></Grid>
            </Grid>
        </Container>

        <WithGqlQuery
            component={EquipmentListWithSearch}
            query={ GET_ALL_EQUIPMENT_REQUESTS_WITH_FULL_DETAIL }
            pageProps={pageProps}
        />
    </div>)
}